module.exports = __webpack_public_path__ + "img/newsLogo7.8b1a7ad8.png";